// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TaskConversation-module__sectionConversation___u2C7F {
  padding: 10px 16px;
  border-bottom: 1px solid #f4f4f5;
  background: #fff;
}

.TaskConversation-module__sectionLabel___r4ozS {
  font-size: 10px;
  font-weight: 600;
  color: #71717a;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 6px;
}

.TaskConversation-module__conversationCard___bMdPJ {
  max-height: 360px;
  overflow-y: auto;
  padding: 2px 0 8px;
  background: #fff;
}

.TaskConversation-module__stateCard___sg6m9 {
  padding: 12px;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #fafafa;
  color: #52525b;
  font-size: 12px;
  line-height: 1.5;
}

.TaskConversation-module__bubbleRow___CFfGx {
  display: flex;
  margin-bottom: 12px;
}

.TaskConversation-module__bubbleRowLeft___Y1v7v {
  justify-content: flex-start;
}

.TaskConversation-module__bubbleRowRight___eLkgt {
  justify-content: flex-end;
}

.TaskConversation-module__bubbleContainer___hNcO0 {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: fit-content;
  max-width: 88%;
}

.TaskConversation-module__bubbleContainerLeft___Pi0rJ {
  align-items: flex-start;
}

.TaskConversation-module__bubbleContainerRight___b9Z_r {
  align-items: flex-end;
}

.TaskConversation-module__bubbleHeader___awL4L {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.TaskConversation-module__senderLabel___PjGuS {
  color: #6b7280;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.3;
  word-break: break-word;
  margin: 0;
}

.TaskConversation-module__senderLabelLeft___XuY8_ {
  text-align: left;
}

.TaskConversation-module__senderLabelRight___uaVfO {
  text-align: left;
}

.TaskConversation-module__bubble___isvrR {
  max-width: 100%;
  padding: 12px 14px;
  border-radius: 10px;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 12px;
  line-height: 1.65;
  border: 1px solid transparent;
}

.TaskConversation-module__bubbleClinic___fqtDV {
  color: #1f2937;
  background-color: #fbfbfc;
  border-color: #d9dde4;
}

.TaskConversation-module__bubbleOther___V0aln {
  color: #1f2937;
  background-color: #f1f9ff;
  border-color: #9fd3ff;
}

.TaskConversation-module__headerDot___Eq0nd,
.TaskConversation-module__headerTime___k5nLk {
  color: #9ca3af;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.3;
}

.TaskConversation-module__attachmentButton___ebDml {
  margin-top: 8px;
  border: 0;
  padding: 0;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  text-decoration: underline;
  background: transparent;
  color: inherit;
}

.TaskConversation-module__replyComposer___cX6zo {
  margin-top: 10px;
  padding: 10px;
  border: 1px solid #dfdfdf;
  border-radius: 8px;
  background: #fafafa;
}

.TaskConversation-module__replyBlockedBanner___d2YOu {
  margin-top: 10px;
  padding: 10px 12px;
  border: 1px solid #f2ca52;
  border-radius: 6px;
  background: #fbf7e8;
  color: #91662f;
  font-size: 14px;
  line-height: 1.45;
}

.TaskConversation-module__replyInput___nR367 {
  width: 100%;
  min-height: 88px;
  resize: vertical;
  padding: 12px;
  border: 1px solid #d7dce3;
  border-radius: 8px;
  background: #fff;
  color: #111827;
  font-size: 12px;
  line-height: 1.55;
  outline: none;
  box-sizing: border-box;
}

.TaskConversation-module__replyInput___nR367::placeholder {
  color: #b3b8c2;
}

.TaskConversation-module__replyInput___nR367:focus {
  border-color: #c4ccd8;
}

.TaskConversation-module__replyFooter___FGIt4 {
  margin-top: 10px;
}

.TaskConversation-module__replyAttachmentInput___gzuc4 {
  display: none;
}

.TaskConversation-module__replyActions___MK41T {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.TaskConversation-module__replyPrimaryButton___wZIIi,
.TaskConversation-module__replySecondaryButton___l6sTy {
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  padding: 8px 14px;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.TaskConversation-module__replyPrimaryButton___wZIIi {
  border: 1px solid #d8dde5;
  background: #f1f3f6;
  color: #9ba3af;
}

.TaskConversation-module__replyPrimaryButton___wZIIi:disabled {
  cursor: not-allowed;
}

.TaskConversation-module__replyPrimaryButton___wZIIi:not(:disabled) {
  background: #ecf5ff;
  border-color: #bfdbfe;
  color: #2563eb;
}

.TaskConversation-module__replySecondaryButton___l6sTy {
  border: 1px solid #d7dce3;
  background: #fff;
  color: #4b5563;
}

.TaskConversation-module__replySecondaryButton___l6sTy:hover {
  background: #f8fafc;
}

.TaskConversation-module__replyAttachmentName___NDBdo {
  margin-top: 8px;
  color: #6d7278;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
}

.TaskConversation-module__replyHint____EOTU {
  margin-top: 8px;
  color: #b0b4bb;
  font-size: 11px;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/TaskConversation/TaskConversation.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gCAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;AACF;;AAEA;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,cAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;AACF;;AAEA;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;AACF;;AAEA;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;AACF;;AAEA;;EAEE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,uBAAA;EACA,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AACF;;AAEA;;EAEE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,kFACE;AAAJ;;AAKA;EACE,yBAAA;EACA,mBAAA;EACA,cAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAFF;;AAKA;EACE,yBAAA;EACA,gBAAA;EACA,cAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAFF","sourcesContent":[".sectionConversation {\n  padding: 10px 16px;\n  border-bottom: 1px solid #f4f4f5;\n  background: #fff;\n}\n\n.sectionLabel {\n  font-size: 10px;\n  font-weight: 600;\n  color: #71717a;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 6px;\n}\n\n.conversationCard {\n  max-height: 360px;\n  overflow-y: auto;\n  padding: 2px 0 8px;\n  background: #fff;\n}\n\n.stateCard {\n  padding: 12px;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  background: #fafafa;\n  color: #52525b;\n  font-size: 12px;\n  line-height: 1.5;\n}\n\n.bubbleRow {\n  display: flex;\n  margin-bottom: 12px;\n}\n\n.bubbleRowLeft {\n  justify-content: flex-start;\n}\n\n.bubbleRowRight {\n  justify-content: flex-end;\n}\n\n.bubbleContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  width: fit-content;\n  max-width: 88%;\n}\n\n.bubbleContainerLeft {\n  align-items: flex-start;\n}\n\n.bubbleContainerRight {\n  align-items: flex-end;\n}\n\n.bubbleHeader {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 8px;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n\n.senderLabel {\n  color: #6b7280;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.3;\n  word-break: break-word;\n  margin: 0;\n}\n\n.senderLabelLeft {\n  text-align: left;\n}\n\n.senderLabelRight {\n  text-align: left;\n}\n\n.bubble {\n  max-width: 100%;\n  padding: 12px 14px;\n  border-radius: 10px;\n  white-space: pre-wrap;\n  word-break: break-word;\n  font-size: 12px;\n  line-height: 1.65;\n  border: 1px solid transparent;\n}\n\n.bubbleClinic {\n  color: #1f2937;\n  background-color: #fbfbfc;\n  border-color: #d9dde4;\n}\n\n.bubbleOther {\n  color: #1f2937;\n  background-color: #f1f9ff;\n  border-color: #9fd3ff;\n}\n\n.headerDot,\n.headerTime {\n  color: #9ca3af;\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 1.3;\n}\n\n.attachmentButton {\n  margin-top: 8px;\n  border: 0;\n  padding: 0;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n  text-decoration: underline;\n  background: transparent;\n  color: inherit;\n}\n\n.replyComposer {\n  margin-top: 10px;\n  padding: 10px;\n  border: 1px solid #dfdfdf;\n  border-radius: 8px;\n  background: #fafafa;\n}\n\n.replyBlockedBanner {\n  margin-top: 10px;\n  padding: 10px 12px;\n  border: 1px solid #f2ca52;\n  border-radius: 6px;\n  background: #fbf7e8;\n  color: #91662f;\n  font-size: 14px;\n  line-height: 1.45;\n}\n\n.replyInput {\n  width: 100%;\n  min-height: 88px;\n  resize: vertical;\n  padding: 12px;\n  border: 1px solid #d7dce3;\n  border-radius: 8px;\n  background: #fff;\n  color: #111827;\n  font-size: 12px;\n  line-height: 1.55;\n  outline: none;\n  box-sizing: border-box;\n}\n\n.replyInput::placeholder {\n  color: #b3b8c2;\n}\n\n.replyInput:focus {\n  border-color: #c4ccd8;\n}\n\n.replyFooter {\n  margin-top: 10px;\n}\n\n.replyAttachmentInput {\n  display: none;\n}\n\n.replyActions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.replyPrimaryButton,\n.replySecondaryButton {\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  padding: 8px 14px;\n  cursor: pointer;\n  transition:\n    background-color 0.15s ease,\n    border-color 0.15s ease,\n    color 0.15s ease;\n}\n\n.replyPrimaryButton {\n  border: 1px solid #d8dde5;\n  background: #f1f3f6;\n  color: #9ba3af;\n}\n\n.replyPrimaryButton:disabled {\n  cursor: not-allowed;\n}\n\n.replyPrimaryButton:not(:disabled) {\n  background: #ecf5ff;\n  border-color: #bfdbfe;\n  color: #2563eb;\n}\n\n.replySecondaryButton {\n  border: 1px solid #d7dce3;\n  background: #fff;\n  color: #4b5563;\n}\n\n.replySecondaryButton:hover {\n  background: #f8fafc;\n}\n\n.replyAttachmentName {\n  margin-top: 8px;\n  color: #6d7278;\n  font-size: 12px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 220px;\n}\n\n.replyHint {\n  margin-top: 8px;\n  color: #b0b4bb;\n  font-size: 11px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sectionConversation": `TaskConversation-module__sectionConversation___u2C7F`,
	"sectionLabel": `TaskConversation-module__sectionLabel___r4ozS`,
	"conversationCard": `TaskConversation-module__conversationCard___bMdPJ`,
	"stateCard": `TaskConversation-module__stateCard___sg6m9`,
	"bubbleRow": `TaskConversation-module__bubbleRow___CFfGx`,
	"bubbleRowLeft": `TaskConversation-module__bubbleRowLeft___Y1v7v`,
	"bubbleRowRight": `TaskConversation-module__bubbleRowRight___eLkgt`,
	"bubbleContainer": `TaskConversation-module__bubbleContainer___hNcO0`,
	"bubbleContainerLeft": `TaskConversation-module__bubbleContainerLeft___Pi0rJ`,
	"bubbleContainerRight": `TaskConversation-module__bubbleContainerRight___b9Z_r`,
	"bubbleHeader": `TaskConversation-module__bubbleHeader___awL4L`,
	"senderLabel": `TaskConversation-module__senderLabel___PjGuS`,
	"senderLabelLeft": `TaskConversation-module__senderLabelLeft___XuY8_`,
	"senderLabelRight": `TaskConversation-module__senderLabelRight___uaVfO`,
	"bubble": `TaskConversation-module__bubble___isvrR`,
	"bubbleClinic": `TaskConversation-module__bubbleClinic___fqtDV`,
	"bubbleOther": `TaskConversation-module__bubbleOther___V0aln`,
	"headerDot": `TaskConversation-module__headerDot___Eq0nd`,
	"headerTime": `TaskConversation-module__headerTime___k5nLk`,
	"attachmentButton": `TaskConversation-module__attachmentButton___ebDml`,
	"replyComposer": `TaskConversation-module__replyComposer___cX6zo`,
	"replyBlockedBanner": `TaskConversation-module__replyBlockedBanner___d2YOu`,
	"replyInput": `TaskConversation-module__replyInput___nR367`,
	"replyFooter": `TaskConversation-module__replyFooter___FGIt4`,
	"replyAttachmentInput": `TaskConversation-module__replyAttachmentInput___gzuc4`,
	"replyActions": `TaskConversation-module__replyActions___MK41T`,
	"replyPrimaryButton": `TaskConversation-module__replyPrimaryButton___wZIIi`,
	"replySecondaryButton": `TaskConversation-module__replySecondaryButton___l6sTy`,
	"replyAttachmentName": `TaskConversation-module__replyAttachmentName___NDBdo`,
	"replyHint": `TaskConversation-module__replyHint____EOTU`
};
module.exports = ___CSS_LOADER_EXPORT___;
